import { Box } from '@mui/material';
import { consentAppSelectors } from 'redux/slices/consent.slice';
import ConsentTermEntry from './ConsentTermEntry';

interface ConsentsAgreementsProps {
  linkKey: string;
}

const ConsentsAgreements = ({ linkKey }: ConsentsAgreementsProps) => {
  const terms = consentAppSelectors.useSelectAllTerms();

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: 2,
        width: '100%',
        maxHeight: 'calc(60vh - 16px)',
        overflowY: 'auto',
        paddingBottom: 2,
      }}
    >
      {terms.map(term => (
        <ConsentTermEntry key={term.key} term={term} linkKey={linkKey} />
      ))}
    </Box>
  );
};

export default ConsentsAgreements;
